import { useEditorState } from "@/state/editorState";
import { Furniture } from "@/state/Furniture";
import { useResourcesState } from "@/state/resourcesState";
import React, { useState } from "react";
import { Dropdown } from "../components/Dropdown/Dropdown";
import { Column } from "../components/Panel/Column";
import { loadModelWithConfig } from "@/api/model";
import { downloadFile } from "@/utils/download";

export const FileManagement = () => {
    const saveModelConfig = useEditorState((state) => state.saveModelConfig);
    const loadModel = useEditorState((state) => state.loadModel);
    const materials = useResourcesState((state) => state.materials);
    const applyConfig = useEditorState((state) => state.applyConfig);
    const setModelWithConfig = useEditorState((state) => state.setModelWithConfig);
    const model = useEditorState((state) => state.model);
    const modelFileName = useEditorState((state) => state.modelFileName);
    const modelPath = useEditorState((state) => state.modelPath);

    const existingFurniture = useResourcesState((state) => state.furniture);
    const [selectedExistingFurnitureId, setSelectedExistingFurnitureId] = useState<
        Furniture["id"] | null
    >(null);

    const [modelUrl, setModelUrl] = useState<string>("/assets/models/");

    const handleSaveToFile = () => {
        const config = useEditorState.getState().getConfig();
        const blob = new Blob([JSON.stringify(config, null, 2)], { type: "application/json" });
        downloadFile(blob, `${modelFileName}.config.json`);
    };

    const handleSaveToLocalDevServer = () => {
        const config = useEditorState.getState().getConfig();
        const blob = new Blob([JSON.stringify(config, null, 2)], { type: "application/json" });

        const modelPathWithName = modelPath ?? "";
        // remove the last part of the path
        const modelPathWithoutName = modelPathWithName.split("/").slice(0, -1).join("/") ?? "";

        console.log({ config, blob, modelPathWithoutName });

        const formData = new FormData();
        formData.append("path", modelPathWithoutName);
        formData.append("file", blob, `${modelFileName}.config.json`);

        fetch("http://localhost:3003/upload", {
            method: "POST",
            body: formData,
        });
    };

    const handleLoadModel = () => {
        if (modelUrl) {
            const fileName = modelUrl.split("/").pop() ?? "LoadedModel";
            loadModel(modelUrl, fileName, materials);
        } else {
            document.getElementById("model-file")?.click();
        }
    };

    const handleLoadExistingFurniture = async () => {
        if (!selectedExistingFurnitureId) {
            return;
        }

        const furniture = existingFurniture[selectedExistingFurnitureId];
        if (!furniture) {
            return;
        }

        let model = furniture.model;
        if (!model) {
            model = await loadModelWithConfig({
                modelPath: furniture.resources.modelPath,
                configPath: furniture.resources.configPath,
            });
        }

        if (!model) {
            return;
        }

        const modelFileName = furniture.resources.modelPath.split("/").pop() ?? furniture.data.name;
        setModelWithConfig(
            furniture.resources.modelPath,
            modelFileName,
            model.raw,
            model.config,
            materials
        );
    };
    return (
        <Column className="p-3">
            <button className="btn btn-primary" onClick={handleLoadExistingFurniture}>
                Загрузить существующую мебель
            </button>
            <Dropdown
                options={Object.values(existingFurniture).map((f) => ({
                    label: f.data.name,
                    value: f.id,
                }))}
                value={selectedExistingFurnitureId}
                onChange={(id) => setSelectedExistingFurnitureId(id)}
            />
            <button className="btn btn-primary" onClick={handleSaveToLocalDevServer}>
                Сохранить через dev файловый сервер
            </button>
            <hr />
            <input
                type="file"
                id="model-file"
                accept=".obj"
                style={{ display: "none" }}
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const content = e.target?.result;
                            if (typeof content === "string") {
                                loadModel(URL.createObjectURL(file), file.name, materials);
                            }
                        };
                        reader.readAsText(file);
                    }
                }}
            />
            <input
                type="file"
                id="config-file"
                accept=".json"
                style={{ display: "none" }}
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const content = e.target?.result;
                            if (typeof content === "string") {
                                const config = JSON.parse(content);
                                applyConfig(config, materials);
                            }
                        };
                        reader.readAsText(file);
                    }
                }}
            />
            <input type="text" value={modelUrl} onChange={(e) => setModelUrl(e.target.value)} />
            <button className="btn btn-secondary" onClick={handleLoadModel}>
                Загрузить модель
            </button>
            <button
                className="btn btn-secondary"
                onClick={() => document.getElementById("config-file")?.click()}
                disabled={!model}
            >
                Загрузить конфиг
            </button>
            <hr />
            <button className="btn btn-secondary" onClick={() => saveModelConfig()}>
                Сохранить в local store
            </button>
            <button className="btn btn-secondary" onClick={handleSaveToFile}>
                Сохранить в файл
            </button>
        </Column>
    );
};
